import { type PromoValue } from './getPromoForOverlay';

export const getApplicableNudgePromo = (promo?: PromoValue) => {
  return promo && promo.threshold ? promo : undefined;
};
